/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Action_Weight_NoneInputs */

const en_us2_search_action_weight_none = /** @type {(inputs: Search_Action_Weight_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nothing logged yet`)
};

const pt_br2_search_action_weight_none = /** @type {(inputs: Search_Action_Weight_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum registro ainda`)
};

const es_419_search_action_weight_none = /** @type {(inputs: Search_Action_Weight_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todavía no hay registros`)
};

const pt_pt2_search_action_weight_none = /** @type {(inputs: Search_Action_Weight_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ainda sem registos`)
};

const fr_fr2_search_action_weight_none = /** @type {(inputs: Search_Action_Weight_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rien d'enregistré pour l'instant`)
};

const de_de2_search_action_weight_none = /** @type {(inputs: Search_Action_Weight_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch nichts eingetragen`)
};

const it_it2_search_action_weight_none = /** @type {(inputs: Search_Action_Weight_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ancora nessuna registrazione`)
};

/**
* | output |
* | --- |
* | "Nothing logged yet" |
*
* @param {Search_Action_Weight_NoneInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_action_weight_none = /** @type {((inputs?: Search_Action_Weight_NoneInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Action_Weight_NoneInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_action_weight_none(inputs)
	if (locale === "es-419") return es_419_search_action_weight_none(inputs)
	if (locale === "pt-PT") return pt_pt2_search_action_weight_none(inputs)
	if (locale === "fr-FR") return fr_fr2_search_action_weight_none(inputs)
	if (locale === "de-DE") return de_de2_search_action_weight_none(inputs)
	if (locale === "it-IT") return it_it2_search_action_weight_none(inputs)
	return en_us2_search_action_weight_none(inputs)
});
export { search_action_weight_none as "search.action_weight_none" }